module.exports = __webpack_public_path__ + "img/life-at-ommax-10.d9772ad3.jpg";